import React from 'react';
import PropTypes from 'prop-types';
import { Button, Col, Row, Spin } from 'antd';
import { Field } from 'redux-form';
import { SelectField, NumberField } from 'redux-form-antd';
import CreativeSelect from '../../../containers/campaign/CreativeSelect';

const formItemLayout = {
  colon: false,
  labelCol: {
    xs: { span: 24 },
    sm: { span: 8 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 16 },
  },
};

/*
 * Hardcoded form select values.
 */
// Priorities.
const priority = [
  { label: '1', value: 1 },
  { label: '2', value: 2 },
  { label: '3', value: 3 },
  { label: '4', value: 4 },
  { label: 'Default is 5', value: 5 },
  { label: '6', value: 6 },
  { label: '7', value: 7 },
  { label: '8', value: 8 },
  { label: '9', value: 9 },
  { label: '10', value: 10 },
];
// Ad Pacing Types.
// Rate Types.
const rateTypes = [{ label: 'Per Day', value: 'day' }, { label: 'All Time', value: 'total' }];

const InStoreTab = ({ handleSubmit, submitting, loading, toggleDeviceCaps, showDeviceCaps }) => (
  <div>
    <Spin spinning={loading}>
      <form name="InStoreTab" onSubmit={handleSubmit}>
        <h2>Pacing</h2>
        <Row>
          <Col span={11}>
            <Field
              {...formItemLayout}
              label="Budget Type"
              name="budget_type"
              component={SelectField}
              options={rateTypes}
            />
            <Field
              {...formItemLayout}
              name="budget"
              label="Budget"
              type="text"
              component={NumberField}
              parse={a => a && !isNaN(Number(a)) && Number(a)}
              format={a => a && !isNaN(Number(a)) && Number(a)}
              placeholder="Default is 1000"
            />
          </Col>
          <Col span={11} offset={2}>
            <Field
              {...formItemLayout}
              name="priority"
              label="Priority"
              type="number"
              parse={a => a && !isNaN(Number(a)) && Number(a)}
              component={SelectField}
              options={priority}
              placeholder="Default is 5"
            />
            <Field
              {...formItemLayout}
              name="cpe"
              min={0}
              type="text"
              label="CPE"
              component={NumberField}
              placeholder="Default is 1"
            />
            <Row>
              <Col offset={8}>
                <a onClick={toggleDeviceCaps} href="#device-caps">
                  {showDeviceCaps ? 'Remove' : 'Add'} Device Frequency Caps
                </a>
              </Col>
            </Row>
          </Col>
        </Row>

        {showDeviceCaps && (
          <div>
            <hr />

            <section>
              <Row>
                <Col span={10} offset={2}>
                  <label>Per user impression limit</label>
                  <Field
                    {...formItemLayout}
                    type="text"
                    name="impression_limit"
                    parse={a => a && !isNaN(Number(a)) && Number(a)}
                    format={a => a && !isNaN(Number(a)) && Number(a)}
                    component={NumberField}
                    placeholder="10"
                  />
                </Col>
                <Col span={10}>
                  <label>Per user impression interval (in seconds)</label>
                  <Field
                    {...formItemLayout}
                    name="impression_interval"
                    type="text"
                    parse={a => a && !isNaN(Number(a)) && Number(a)}
                    format={a => a && !isNaN(Number(a)) && Number(a)}
                    component={NumberField}
                    placeholder="X seconds"
                  />
                </Col>
              </Row>
            </section>
          </div>
        )}

        <hr />

        <h2>Creative</h2>

        <CreativeSelect handleSubmit={handleSubmit} disabled={submitting} loading={submitting} />

        <Button size="large" onClick={handleSubmit} loading={submitting} type="primary">
          Update
        </Button>
      </form>
    </Spin>
  </div>
);

InStoreTab.defaultProps = {
  submitting: false,
};

InStoreTab.propTypes = {
  submitting: PropTypes.bool,
  handleSubmit: PropTypes.func.isRequired,
};

export default InStoreTab;
